import React, { useMemo } from "react";
import DeviceItem from "./DeviceItem";
import { useDeviceConfigEntries } from "../../../hooks/useReduxSelectors";
import { Box } from "@mui/material";

const FilterView = React.memo(({ filter }) => {
  const devices = useDeviceConfigEntries();

  const filteredDevices = useMemo(() => {
    if (!devices || devices.length === 0) return [];
    if (!filter) return devices;

    const lowerFilter = filter.toLowerCase();

    return devices
      .map((device) => {
        if (device.name.toLowerCase().includes(lowerFilter) ||
          (device.tag && device.tag.toLowerCase().includes(lowerFilter))) {
          return device;
        }

        const matchingMeasurements = device.measurements.filter((m) =>
          m.name.toLowerCase().includes(lowerFilter)
        );
        const matchingDiagnostics = device.diagnostics?.filter((d) =>
          d.name.toLowerCase().includes(lowerFilter)
        ) || [];

        if (matchingMeasurements.length > 0 || matchingDiagnostics.length > 0) {
          return {
            ...device,
            measurements: matchingMeasurements,
            diagnostics: matchingDiagnostics,
          };
        }

        return null;
      })
      .filter(Boolean);
  }, [filter, devices]);


  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minWidth: 0, overflow: "hidden" }}>
      <Box
        sx={{
          maxHeight: "100%",
          minHeight: "350px",
          minWidth: 0,
          overflowY: "auto",
          overflowX: "hidden",
          pr: 1,
        }}
      >
        {filteredDevices.map((device) => (
          <DeviceItem
            key={device.hwId}
            device={device}
          />
        ))}
      </Box>
    </Box>
  );
});

export default FilterView;
